<router-outlet></router-outlet>
<div *ngIf="isSpinnerVisible">
  <mat-progress-bar class="loader" mode="indeterminate" value="40"></mat-progress-bar>
</div>
